import React, { useContext } from 'react';
import { TextContext } from '../../context/TextCotext';
import Navbar from '../navbar/Navbar';
import AppLogout from './AppLogout';

export default function Layout({ children }) {
  const PLANT_NAME = localStorage.getItem('plantName');
  const { version } = useContext(TextContext);
  return (
    <AppLogout>
      <div className="flex flex-col min-h-screen overflow-x-hidden">
        <Navbar />
        <div className="flex-grow w-full box-border px-4 md:px-6 py-4 mt-16 overflow-x-hidden" 
             style={{ 
               height: 'calc(100vh - 8rem)', // ارتفاع ثابت برای محتوا
               overflowY: 'auto' // اسکرول عمودی فقط برای محتوا
             }}>
          {children}
        </div>
        <footer className="sticky bottom-0 bg-gray-50 shadow-lg z-50">
          <div className="py-4 px-6 flex justify-between items-center">
            <div className="text-gray-600 text-sm">
              Developd by{' '}
              <a
                href="https://farscada.ir/"
                target="_blank"
                className="text-cyan-600 hover:text-cyan-400 font-bold transition-colors"
              >
                Hamrah Houshmand{' '}
                <span className="text-xs text-indigo-600">OFOGH</span>
              </a>
            </div>
            <div className="font-semibold text-gray-500 text-sm">
              {PLANT_NAME}
            </div>
            <div className="text-gray-500 text-sm">Version: {version}</div>
          </div>
        </footer>
      </div>
    </AppLogout>
  );
}